import { render } from "./traCourseAdd.vue?vue&type=template&id=55f6d4ee&scoped=true"
import script from "./traCourseAdd.vue?vue&type=script&lang=js"
export * from "./traCourseAdd.vue?vue&type=script&lang=js"

import "./traCourseAdd.vue?vue&type=style&index=0&id=55f6d4ee&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f6d4ee"]])

export default __exports__